 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		283: 0,
 		280: 0,
 		281: 0,
 		291: 0,
 		339: 0,
 		340: 0,
 		347: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","217":"AddClosedAlertIDUseCase","218":"CreateDeviceUseCase","219":"CreateDomestikaFollowUseCase","220":"CreateJWTUserUseCase","221":"CreateUserLiveSessionUseCase","222":"CurrentUserUseCase","223":"CurrentWithoutRelationshipsUserUseCase","224":"DeleteDeviceUseCase","225":"DeleteFollowUseCase","226":"ENV_CONFIG1","227":"ENV_CONFIG4","228":"ENV_CONFIG5","229":"ENV_CONFIG6","230":"ENV_CONFIG7","231":"FinishUserLiveSessionUseCase","232":"GetAccessTokenUserUseCase","233":"GetAdvanceGDPRStatusUserUseCase","234":"GetAllBlogUseCase","235":"GetAreasCourseUseCase","236":"GetCartCourseUseCase","237":"GetCategoriesCourseUseCase","238":"GetCourseUseCase","239":"GetFinalProjectVideoByCourseIDCourseUseCase","240":"GetGDPRStatusUserUseCase","241":"GetListLiveFeedbackQuestionUseCase","242":"GetListLiveSessionUseCase","243":"GetListLiveStreamUseCase","244":"GetLiveChannelUseCase","245":"GetLiveSessionUseCase","246":"GetOrganizationUseCase","247":"GetPlusPromotionUseCase","248":"GetPostContentBlogUseCase","249":"GetPromotionCodeAlertUseCase","250":"GetPromotionUseCase","251":"GetPubnubCredentialsUseCase","252":"GetSessionDataUserUseCase","253":"GetSimpleUserUseCase","254":"GetSoftwaresCourseUseCase","255":"GetUserAlertUseCase","256":"GetVideoProgressListCourseUseCase","257":"GetVideoSpeedUserUseCase","258":"GetVideoVolumeUserUseCase","259":"LogoutUserUseCase","260":"PathToRegexp","261":"RefreshAccessTokenUserUseCase","262":"RemoveAccessTokenUserUseCase","263":"SearchCourseUseCase","264":"SendHeaderTrackingUseCase","265":"SendLiveFeedbackAnswersUseCase","266":"SendPlayerTrackingUseCase","267":"SendTrackingUseCase","268":"SendVideoProgressCourseUseCase","269":"SetAdvanceGDPRStatusUserUseCase","270":"SetGDPRStatusUserUseCase","271":"SetVideoSpeedUserUseCase","272":"SetVideoVolumeUserUseCase","273":"UpdateLanguageUserUseCase","274":"UpdateLiveSessionUseCase","275":"UpdateVideoAudioAndSubtitlesCourseUseCase","276":"UpdateVideoProgressCourseUseCase","277":"ViewPageTrackingUseCase","348":"vendors~AddClosedAlertIDUseCase","349":"vendors~AmplitudeJS","350":"vendors~SearchCourseUseCase","351":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"3963fd6db8dbf4c19728","1":"fc2b1e1a32aa510b6cb8","2":"3be4ef81ae96fd3f7888","3":"a73e9dbb389f5e0cdb2f","4":"accbe76947d14647bd7f","5":"37403b8e50b4ef76e17f","6":"b0cc36ca2afc12e06080","216":"308f56c2e369d5dc2e89","217":"b1f2ed5cae4fae4618f4","218":"f8d6972082b7c447fcc5","219":"0c0590a27df4ad73c202","220":"53c605ea8cff77e57ec2","221":"346477168138f5da4e5c","222":"f4436c1740abad39b37c","223":"25c661bd73c79d1e1605","224":"0bfc222914d734fc3858","225":"2e91143fd327bb96ecce","226":"f1c43e61a9cd6af4b62a","227":"7c5637ffa7ad5e2d4a61","228":"414384cfa4cf5a7a449a","229":"6b8c2e96facae9eda6fe","230":"beda36b5457f95a3cbbd","231":"4791b5ab6b35edc978df","232":"37445387ca9bcb3715f5","233":"ccf0c29b4a71402460e7","234":"ceb9a1aaa654a1c1418a","235":"c195ac771dd492ee704a","236":"42b61856e29bee17ee73","237":"e5f89805d4be3a3c5efd","238":"a2ff00364373a7cf64cd","239":"dfba1f8cc3360ff4fb13","240":"0efb1b1bc92c7562d3e4","241":"6bac5aab36ba2ee8a1a2","242":"e5aa09677423fdbb818a","243":"11716658440a45e8cf42","244":"2cf69da8142e931a8191","245":"cdaafe7ce405bd9fea8c","246":"a5707c50f4b9df5f04c5","247":"7f1040581d4bfc9bf295","248":"db9b89c03b1911a08a0c","249":"47139d98a7caa944017d","250":"e47e803b87d85d74bfe2","251":"ef62b6c0c6c99fc970ed","252":"cc0ce986d4707b49f6d8","253":"1ee2bd29745f432d5342","254":"e933cb832accd9430086","255":"849731ebb20715ff0dbc","256":"921111f9c907f3b103ff","257":"b335f7ba0dcf5044c3ec","258":"dfcad8d98b85d31c84a8","259":"b31ae43e5a0b1d47e8fc","260":"dd37dfd8309bcb97c265","261":"f4bff90445d94274caca","262":"5e1a635c727ec5001f82","263":"c09588737625eca58657","264":"59108bb2fa2569424e5a","265":"00dd87569035a6ede1ee","266":"b4ccf20748e9568692a0","267":"70e098387c4d945b3853","268":"1c1b85700fd0fcb27071","269":"8afbe7808166e0651a4a","270":"183f126beefe3d76f648","271":"ea3c02ebeec215fb74ee","272":"6fc34c6bf5be6754ff9e","273":"588f2d2ffd095a38e51a","274":"fef6c9dcac7e2d2040de","275":"696b3ae77a79fa16cf0e","276":"84f758d20ebb02a6b2b7","277":"923205efc5d2632f496e","348":"e1028f14a3b989b7eeb9","349":"f54868869d261b10ba8a","350":"892ba66d99434266fc3a","351":"e630fe35d81ffd25f906","420":"fe3b3cb4f612c09563c8","422":"69e84e88149a041917ef","423":"0452533f67ec4c1f35ff","641":"95e0883e268b6f965d51","642":"a9503fbb9d714df0817a","643":"00b530da38fade2d2c34"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2037);
